import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const ProgramaCEA = lazy(() => import('../../../views/ProgramaCEA/index'))

const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} component={ProgramaCEA} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
